<div class="py-5 qm-bg-catskillWhite home-page h-100">
  <div class="text-center qm-text-accent mb-5">
    <p class="fw-bolder">Welcome to use QM Internal Admin Portal</p>
    <p class="fw-bolder">Please select a service to start</p>
  </div>
  <!-- menu items -->
  @if (adminUserMenuGroup?.length > 0) {
    <div class="w-75 mx-auto">
      <div class="row" [ngClass]="{ 'justify-content-center': adminUserMenuGroup?.length < 3 }">
        @for (group of adminUserMenuGroup; track group.Code) {
          <!-- menu group -->
          <div class="col-4 mb-4">
            <div class="card h-100 shadow-sm">
              <div class="card-body">
                <h5 class="card-title">
                  <span class="material-icons">dashboard</span>
                  &nbsp;
                  <span class="align-top">{{ group.GroupName }}</span>
                </h5>
                <div class="card-text">
                  @for (menu of group.Items; let isLast = $last; track menu) {
                    <a
                      mat-flat-button
                      class="me-4 mb-3"
                      [routerLink]="[menu.ItemLink]"
                      (click)="loginService.doGoogleTracking('InternalAdminPortal', 'home', menu.TrackingName)"
                    >
                      {{ menu.ItemName }}
                    </a>
                  }
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- no menu items -->
  @if (!adminUserMenuGroup || adminUserMenuGroup.length <= 0) {
    <div class="container alert alert-danger text-center">
      Sorry you do not have any accessible function, please contact QM IT Team to change your access Permissions.
    </div>
  }
</div>
